import { useAuth } from 'context/auth'
import React from 'react'

export default function LogoSistema({ identificacaoLogo, width, style = {}, className = "" }) {
    const { setupSistema } = useAuth();

    return (
        <>
            {identificacaoLogo == "logotipo" &&
                <img
                    className={className}
                    src={setupSistema?.caminhoVirtual + "logo.png"}
                    width={width}
                    style={{ ...style }}
                />
            }
            {identificacaoLogo == "logoSecundario" &&
                <img
                    className={className}
                    src={setupSistema?.caminhoVirtual + "logoSecundario.png"}
                    style={{ ...style }}
                />
            }
            {identificacaoLogo == "logotipoBranco" &&
                <img
                    className={className}
                    src={setupSistema?.caminhoVirtual + "logoBranco.png"}
                    width={width}
                    style={{ ...style }}
                />
            }
            {identificacaoLogo == "logoSecretariaBranco" &&
                <img
                    className={className} src={setupSistema?.caminhoVirtual + "logoSecretariaBranco.png"}
                    width={width}
                    style={{ ...style }}
                />
            }
        </>
    )
}